module.exports = __webpack_public_path__ + "static/media/delete.ce339cdf.png";